<template>
    <el-card class="box-card">
        <el-tabs v-model="activeName" @tab-click="tabClickChange">
            <el-tab-pane name="first" label="广播推送记录查询">
                <el-table :data="dataHandled" border>
                    <el-table-column prop="adminName" width="100px" label="后台操作人"></el-table-column>
                    <el-table-column prop="gmtCreate" width="150px" label="发送时间"></el-table-column>
                    <el-table-column prop="startTime" width="150px" label="开始时间"></el-table-column>
                    <el-table-column prop="endTime" width="150px" label="结束时间"></el-table-column>
                    <el-table-column prop="intervals" width="80px" label="时间间隔"></el-table-column>
                    <el-table-column prop="content" label="内容">
                        <template slot-scope="scope">
                            <div v-for="(value,key) in JSON.parse(scope.row.content)">
                                <span v-if="key == 'zh-Hans'">简中</span>
                                <span v-if="key == 'zh-Hant'">繁中</span>
                                <span v-if="key == 'ja-JP'">日文</span>
                                <span v-if="key == 'ko-KR'">韩文</span>
                                <span v-if="key == 'ru-RU'">俄文</span>
                                <span v-if="key == 'en-US'">英文</span>
                                <span>({{key}}): {{value}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="worldUri" label="uri"></el-table-column>
                    <el-table-column label='操作'>
                        <template slot-scope="scope">
                            <span v-if="(new Date(scope.row.endTime).getTime() < new Date().getTime())">已结束广播</span>
                            <template v-else>
                                <el-button type="text" @click="openSysMsg(scope.row.id)" v-if="!scope.row.effective">继续广播</el-button>
                                <el-button type="text" @click="closeSysMsg(scope.row.id)" v-if="scope.row.effective">停止广播</el-button>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                                   :page-size="pageSize"
                                   layout="total, prev, pager, next, jumper" :total="totalRow">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane name="second" label="推送广播">
                <div class="component-content">

                    <el-form label-suffix=":">
                        <el-form-item label="选服模式">
                            <el-select v-model="selectMode">
                                <el-option v-for="item in selectOption" :key="item.id"
                                           :label="item.lang"
                                           :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="当前对外开放的服务器" v-if="selectMode === 'currentOpen'">
                                <span v-for="item in loginInfoGame" :key="'server' + item.id"
                                      v-if="item.server_load !== 4 && item.server_load !== 4">
                                            {{item.server_number}}({{item.server_name}}),
                                </span>
                        </el-form-item>
                        <el-form-item label="当前已配置的服务器" v-if="selectMode === 'currentAll'">
                                <span v-for="item in loginInfoGame" :key="'server' + item.id">
                                            {{item.server_number}}({{item.server_name}}),
                                </span>
                        </el-form-item>
                        <el-form-item v-if="selectMode === 'serverArray'">
                            <component-server @gameValue="getGameValue" :serverMode="'mode_game'"></component-server>
                        </el-form-item>
                    </el-form>

                    <el-card>
                        <el-form :model="gmChatForm" label-suffix=":">
                            <el-form-item label="玩家渠道开关">
                                <el-switch
                                    v-model="channelListSwitch"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    active-text="自选"
                                    inactive-text="全选"
                                    :active-value="true"
                                    :inactive-value="false">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="玩家渠道" v-if="channelListSwitch">
                                <el-select v-model="gmChatForm.channelList" multiple>
                                    <el-option
                                        v-for="item in channelData"
                                        :key="item.value"
                                        :value="item.value.toString()"
                                        :label="item.value + '(' + item.channel + ')'">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="内部操作原因">
                                <el-autocomplete
                                    class="inline-input"
                                    type="textarea"
                                    :maxlength="300"
                                    show-word-limit
                                    :autosize="{ minRows: 2}"
                                    v-model="gmChatForm.reason"
                                    :fetch-suggestions="querySearchReasonTemplate"
                                    placeholder="请输入内容"
                                    @select="handleSelect"
                                >
                                    <template slot-scope="{ item }">
                                        <span class="addr">{{item.reason}}</span>
                                    </template>
                                </el-autocomplete>
                            </el-form-item>
                            <el-form-item label="立即发送开关">
                                <el-switch
                                    v-model="gmChatForm.sendNow"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    :active-value="true"
                                    :inactive-value="false">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="时区：">
                                <el-select v-model="localZoneTime">
                                    <el-option
                                        v-for="localZoneTimeItem in localZoneTimeOptions"
                                        :key="localZoneTimeItem.value"
                                        :value="localZoneTimeItem.value"
                                        :label="localZoneTimeItem.label">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="时间" v-if="!gmChatForm.sendNow">
                                <el-date-picker v-model="localDateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" @change="getGmtStarted()">
                                </el-date-picker>
                                <span>至</span>
                                <el-date-picker v-model="localDateTime2" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" @change="getGmtEnded()">
                                </el-date-picker>
                                <span class="gm-tip">(秒选择30的倍数)</span>
                            </el-form-item>

                            <el-form-item label="本地时间" v-if="!gmChatForm.sendNow&& dateTime && dateTime2">
                                <span class="gm-tip">{{localDateTime3}}</span>
                                <span>至</span>
                                <span class="gm-tip">{{localDateTime4}}</span>
                                <span class="gm-tip">(utc{{localZoneTime}})</span>
                            </el-form-item>
                            <el-form-item label="服务器时间" v-if="!gmChatForm.sendNow&& dateTime && dateTime2">
                                <span class="gm-tip">{{dateTime}}</span>
                                <span>至</span>
                                <span class="gm-tip">{{dateTime2}}</span>
                                <span class="gm-tip">(utc{{serverZoneTime}})</span>
                            </el-form-item>

                            <el-form-item label="广播间隔" v-if="!gmChatForm.sendNow">
                                <el-input-number v-model="gmChatForm.intervals" :min="0"></el-input-number>
                                秒
                                <span class="gm-tip">(填入30的倍数)</span>
                                <span>快捷按钮:
                                    <el-button @click="gmChatForm.intervals = 60">60</el-button>
                                    <el-button @click="gmChatForm.intervals = 120">120</el-button>
                                    <el-button @click="gmChatForm.intervals = 300">300</el-button>
                                    <el-button @click="gmChatForm.intervals = 600">600</el-button>
                                </span>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <template v-for="(item,index) in langForContent">
                        <el-card :key="index">
                            <div slot="header" class="clearfix">
                                <span>公告 - {{item.lang}} - {{item.val}}</span>
                                <span>(当前已输入{{Util.countStringLength(item.content)}}/400)字符</span>
                            </div>
                            <el-form label-position="left" label-width="100px">
                                <el-form-item :label="item.lang+'公告'" >
                                    <el-input :placeholder="'请输入'+item.val+'公告内容'" v-model="item.content">
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </el-card>
                    </template>
                </div>
                <div class="confirm-btn" v-if=" langForContent.length > 0 ">
                    <el-button type="primary" @click="saveGmChat()">确定发布</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
    import paginationController from '../../mixins/pagination'
    import lang_config from '../../data/lang_config.json';
    import actionConfirm from '../../mixins/action_confirm'
    import broadcastApi from '../../service/broadcast_api';
    import configSettingApi from '../../service/config_setting_api'
    import utils from '../../lib/utils'
    import {
        mapState
    } from 'vuex';
    import componentServer from '../../components/component_server'
    import confApi from '../../service/conf_api'
    import commonApi from "../../service/common_api";

    export default {
        name: "logs",
        data() {
            return {
                title: this.$route.meta.title,
                serverZoneTime: Global_Config_Yunwei.serverZoneTime,
                Util: utils,
                langs: lang_config,
                langForContent: [],
                limitLen: 400,

                localZoneTime: 8,
                localZoneTimeOptions: [
                    {
                        label: 'utc8',
                        value: 8
                    },
                    {
                        label: 'utc-5',
                        value: -5
                    }
                ],

                activeName: 'first',
                worldServer: '',
                gameServerData: [],
                loginInfoGame:[],
                loginInfoWorld:[],
                selectOption:[
                    {
                        id:'currentAll',
                        lang:'全服2（当前已配置的全部服务器）'
                    },
                    {
                        id:'currentOpen',
                        lang:'全服3（已对外开放的服务器）'
                    },
                    {
                        id:'serverArray',
                        lang:'手动选服'
                    }
                ],
                selectMode:'currentOpen',
                // 模板数据
                reasonTemplateData: [],

                gmChatForm: {
                    reason: '',
                    intervals: 0,
                    startTime: '',
                    endTime: '',
                    sendNow: false,
                    channelList: []
                },
                dateTime: '',
                dateTime2: '',

                localDateTime: '',
                localDateTime3: '',
                localDateTime2: '',
                localDateTime4: '',

                // 渠道数据
                channelData: [],

                // 渠道开关
                channelListSwitch: false,


                pickerOptions: {
                    shortcuts: [
                        {
                            text: '此刻',
                            onClick(picker) {
                                const end =  new Date(new Date().setSeconds( 0, 0));
                                const start = new Date(new Date().setSeconds( 0, 0));
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                },
            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
            }),
        },
        created() {
            // this.getLimitVal();
            this.getReasonListAll();
            this.getChannelsList();
            this.loadActivityInfo();
        },
        mounted() {
            this.getLangs();
            this.findAllGM();
            let langContents = [];
            setTimeout(() => {
                this.langType.forEach(item=>{
                    langContents.push({
                        id:item.id,
                        val:item.val,
                        content:"",
                        lang:item.label
                    })
                })
                this.langForContent = langContents;
            },2000)
        },
        methods: {
            getGmtStarted() {
                let self = this;
                const date = new Date(self.localDateTime);
                let localTime = '';
                let localTimeZone = self.localZoneTime;

                localTime = date;
                self.localDateTime3 = utils.formatDate(localTime);

                let time = '';
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time = localTime;
                    } else if (timeZone == 8) {
                        time = self.west5TimeToEast8Time(date)
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time = self.toWest5Time(date)
                    } else if (timeZone == 8) {
                        time = localTime;
                    }
                }

                self.dateTime = utils.formatDate(time);
            },

            getGmtEnded() {
                let self = this;
                const date = new Date(self.localDateTime2);
                let localTime = '';
                let localTimeZone = self.localZoneTime;

                localTime = date;
                self.localDateTime4 = utils.formatDate(localTime);

                let time = '';
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time = localTime;
                    } else if (timeZone == 8) {
                        time = self.west5TimeToEast8Time(date)
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time = self.toWest5Time(date)
                    } else if (timeZone == 8) {
                        time = localTime;
                    }
                }

                self.dateTime2 = utils.formatDate(time);
            },

            loadActivityInfo() {
                let self = this;
                commonApi.getConfs({
                    tables: 'login_info_game,login_info_world'
                }).then(res => {
                    let sourceGameInfo = res.login_info_game;
                    this.loginInfoGame = [];
                    let subGameInfo = [];
                    for (let tmpItem of sourceGameInfo) {
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoGame.push(tmpItem);
                        } else {
                            subGameInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subGameInfo) {
                        this.loginInfoGame.forEach(mainGameServer => {
                            if (tmpItem.combine_server_number === mainGameServer.server_number) {
                                mainGameServer.children.push(tmpItem);
                            }
                        })
                    }

                    this.loginInfoGame.sort((a, b) => {
                        let aServerNum = a.server_number>>0;
                        let bServerNum = b.server_number>>0;

                        if (aServerNum > bServerNum){
                            return 1;
                        }
                        if (aServerNum < bServerNum) {
                            return -1;
                        }
                        return 0;
                    });

                    let sourceWorldInfo = res.login_info_world;
                    this.loginInfoWorld = [];
                    let subWorldInfo = [];
                    for (let tmpItem of sourceWorldInfo) {
                        tmpItem.server_maintenance = -1;
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoWorld.push(tmpItem);
                        } else {
                            subWorldInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subWorldInfo) {
                        this.loginInfoWorld.forEach(mainServer => {
                            if (tmpItem.combine_server_number === mainServer.server_number) {
                                mainServer.children.push(tmpItem);
                            }
                        })
                    }

                    this.loginInfoWorld.sort((a, b) => {
                        let aServerNum = a.server_order>>0;
                        let bServerNum = b.server_order>>0;

                        if (aServerNum > bServerNum) {
                            return 1;
                        }
                        if (aServerNum < bServerNum) {
                            return -1;
                        }
                        return 0;
                    });
                })
            },

            getLimitVal(){
                let self = this;
                confApi.getReadData({
                    token: self.token,
                    tableName: 'user_configuration'
                }).then(res => {
                    res.forEach(item => {
                        if (item.id == 1401) {
                            self.limitLen = parseInt(item.key_value) * 2;
                        }
                    })
                })
            },
            getGameValue(val) {
                //this.gameServer = uri;
                this.gameServerData = [];
                this.serverGameList.forEach(item => {
                    val.forEach(item2 => {
                        if (item.id == item2) {
                            this.gameServerData.push(item);
                        }
                    })
                })
            },
            saveGmChat() {
                let self = this;
                for (let i = 0; i < self.langForContent.length; i++) {
                    let item = self.langForContent[i];
                    let curLen = utils.countStringLength(item.content);
                    if (curLen > self.limitLen){
                        self.$message({
                            type: 'error',
                            message: "最多输入400字符（已输入"+ curLen+"字符），请调整输入内容"
                        })
                        return;
                    }
                }

                let content = {};
                let nullCount = 0;
                self.langForContent.forEach(item=>{
                    content[item.val] = item.content;
                    if (item.content == ''){
                        nullCount++;
                    }
                })
                if (nullCount == self.langForContent.length){
                    self.$message({
                        type: 'error',
                        message: "请至少填写一种语言的公告"
                    })
                    return;
                }

                var data = self.gmChatForm;


                data.startTime = utils.formatDate(self.dateTime);
                data.endTime = self.dateTime2;

                if (!data.sendNow) {
                    if (data.endTime == undefined || data.endTime == '') {
                        self.$message({
                            type: 'error',
                            message: "请选择完整时间段"
                        })
                        return;
                    }
                }

                var userChannels = '';
                if (!self.channelListSwitch) {
                    userChannels = '0';
                } else {
                    userChannels = data.channelList.join(',');
                }

                let uriArray = [];
                let serverNumberArray = [];
                if (self.selectMode == 'currentAll'){
                    self.loginInfoGame.forEach(item=>{
                        uriArray.push(item.inner_urls.split(";")[0]);
                        serverNumberArray.push(item.server_number);
                    })
                }
                else if (self.selectMode == 'currentOpen'){
                    self.loginInfoGame.forEach(item=>{
                        if (item.server_load != 4 && item.server_load != 6){
                            uriArray.push(item.inner_urls.split(";")[0]);
                            serverNumberArray.push(item.server_number);
                        }
                    })
                }
                else if (self.selectMode == 'serverArray'){
                    self.gameServerData.forEach(gameServerItem =>{
                        uriArray.push(gameServerItem.inner_urls.split(";")[0]);
                        serverNumberArray.push(gameServerItem.server_number);
                    })
                }

                if (uriArray.length <= 0){
                    self.$message({
                        type: 'error',
                        message: "请选择一个游戏服"
                    })
                    return;
                }

                broadcastApi.saveBroadcast({
                    sendForm: {
                        uri: uriArray.join(";"),
                        gameServers: serverNumberArray.join(";"),
                        content: JSON.stringify(content),
                        // adminName: 'xxx',
                        startTime: data.startTime,
                        endTime: data.endTime,
                        reason: data.reason,
                        intervals: data.intervals,
                        sendNow: data.sendNow,
                        userChannels: userChannels
                    },
                    token: self.token
                }).then(res => {
                    self.$message({
                        type: 'success',
                        message: "发送成功"
                    })
                })
            },

            tabClickChange(tab,event) {
                if (tab.name == 'first') {
                    this.findAllGM();
                } else if (tab.name == 'second') {
                    let langContents = [];
                    setTimeout(() => {
                        this.langType.forEach(item=>{
                            langContents.push({
                                id:item.id,
                                val:item.val,
                                content:"",
                                lang:item.label
                            })
                        })
                        this.langForContent = langContents;
                    },2000)
                }
            },

            findAllGM() {
                let self = this;
                broadcastApi.findAllBroadcast(this.token).then(res => {
                    self.rawData = res;
                    self.totalRow = res.length;
                })
            },

            // 模板列表查询
            getReasonListAll() {
                configSettingApi.reasonList({
                    token: this.token
                }).then(res => {
                    this.reasonTemplateData = res;
                })
            },

            querySearchReasonTemplate(queryString, cb) {
                var data = this.reasonTemplateData;
                var results = queryString ? data.filter(this.createFilter(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilter(queryString) {
                return (data) => {
                    return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                this.gmChatForm.reason = item.reason;
            },

            // 继续广播
            openSysMsg(id) {
                var switchSysMsgForm = {
                    id: id,
                    effective: true
                }
                broadcastApi.changeBroadcast({
                    token: this.token,
                    switchSysMsgForm: switchSysMsgForm
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: "操作成功"
                    })
                    this.findAllGM();
                })
            },

            // 停止广播
            closeSysMsg(id) {
                var switchSysMsgForm = {
                    id: id,
                    effective: false
                }
                broadcastApi.changeBroadcast({
                    token: this.token,
                    switchSysMsgForm: switchSysMsgForm
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: "操作成功"
                    })
                    this.findAllGM();
                })
            },

            // 渠道列表
            getChannelsList() {
                configSettingApi.channelList({
                    token: this.token
                }).then(res => {
                    this.channelData = res;
                })
            },
        },
        components: {
            componentServer
        }
    }
</script>

<style lang="less" scoped>
    .confirm-btn {
        text-align: center;
    }
    .el-card {
        margin: 10px 0 !important;
    }

    .gm-tip{
        color: red;
    }
    .inline-input {
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/maintenance/gm_chat.vue